// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEoyPlanReconciliationApproveDto
 */
export interface IEoyPlanReconciliationApproveDto {
    /**
     * 
     * @type {number}
     * @memberof IEoyPlanReconciliationApproveDto
     */
    invoice_id: number;
    /**
     * 
     * @type {number}
     * @memberof IEoyPlanReconciliationApproveDto
     */
    invoice_amount: number;
}

/**
 * Check if a given object implements the IEoyPlanReconciliationApproveDto interface.
 */
export function instanceOfIEoyPlanReconciliationApproveDto(value: object): value is IEoyPlanReconciliationApproveDto {
    if (!('invoice_id' in value) || value['invoice_id'] === undefined) return false;
    if (!('invoice_amount' in value) || value['invoice_amount'] === undefined) return false;
    return true;
}

export function IEoyPlanReconciliationApproveDtoFromJSON(json: any): IEoyPlanReconciliationApproveDto {
    return IEoyPlanReconciliationApproveDtoFromJSONTyped(json, false);
}

export function IEoyPlanReconciliationApproveDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEoyPlanReconciliationApproveDto {
    if (json == null) {
        return json;
    }
    return {
        
        'invoice_id': json['invoice_id'],
        'invoice_amount': json['invoice_amount'],
    };
}

export function IEoyPlanReconciliationApproveDtoToJSON(json: any): IEoyPlanReconciliationApproveDto {
    return IEoyPlanReconciliationApproveDtoToJSONTyped(json, false);
}

export function IEoyPlanReconciliationApproveDtoToJSONTyped(value?: IEoyPlanReconciliationApproveDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoice_id': value['invoice_id'],
        'invoice_amount': value['invoice_amount'],
    };
}

